import { atom } from 'jotai';
import { ListedInstrument, QuoteChartEntry } from '../../types';
import { LoadableState } from '../../utils';

/** Stores the chart entries displayed in the index row keyed by the ric of the instrument they belong to */
export const indexRowChartDataAtom = atom<Record<string, LoadableState<QuoteChartEntry[]>>>({});

/** Stores the plain ListedInstruments used in the index row keyed by the ric of the instrument they belong to */
export const indexRowListedInstrumentsAtom = atom<Record<string, LoadableState<ListedInstrument>>>({});

/** This is for updating (polling) the chart used in the index row. When this updates, the chart reloads. */
export const indexRowChartPollingAtom = atom<number>(0);

/**
 * This is for refreshing the index row with most of it's related data by incrementing this value. It affects:
 * - The instrument (providing only the name)
 * - The chart data
 * It doesn't affect:
 * - The instrument store/estream subscription
 */
export const indexRowRefreshVersionAtom = atom<number | undefined>(undefined);
